<div class="form-group">
  <label [for]="name">{{placeholder | titlecase}}</label>
  <span class="p-fluid">
    <p-chips [(ngModel)]="model" (onAdd)="eventChange($event)" (onRemove)="eventChange($event)"></p-chips>
  </span>
</div>